import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';

import { Advertiser, User } from '../../../_models';
import { AuthenticationService, NotificationService, AdvertiserService } from '../../../_services';

@Component({ templateUrl: './advertiser-list.component.html' })
export class AdvertiserListComponent implements OnInit {
  advertisers: Advertiser[];
  currentUser: User;
  loading = false;
  showError = false;
  itemsPerPage = 10;
  pagingList = [10, 20, 40, 60, 80, 100];
  totalItems = 0;
  maxSize = 11;
  numPages = 0;
  currentPage = 1;
  page: number;
  goToPage: number;
  emptyResult = false;
  maxPageSize: number;

  initialized = false;

  filterable = {
    advertiser: null,
    offerId: null,
  };

  constructor(
    private authSvc: AuthenticationService,
    private advertiserSvc: AdvertiserService,
    private notification: NotificationService) {

    this.currentUser = this.authSvc.currentUserValue;
  }

  ngOnInit(): void {
    this.loadPage(1);
  }

  search(): void {
    this.totalItems = 0;
    this.loadPage(1);
  }

  clear(): void {
    this.filterable = {
      advertiser: null,
      offerId: null,
    };
  }

  setPage(pageNo: number): void {
    this.currentPage = pageNo;
    this.loadPage();
  }

  pageChanged(event: any): void {
    this.page = event.page;
    if (this.page != this.currentPage) {
      this.loadPage(this.page);
    }
  }

  itemsPerPageChange(deviceValue) {
    this.itemsPerPage = deviceValue;
    this.loadPage(1);
  }

  deleteAdvertiser(advertiser) {
    if (confirm("Are you sure to delete this advertiser?")) {
      this.advertiserSvc.deleteAdvertiser(advertiser.id).subscribe(data => {
        if (data.status == 1) {
          this.notification.showSuccess("Advertiser deleted successfully!", "Delete Advertiser");
          this.loadPage(1);
        } else {
          this.notification.showError("Error deleting advertiser, please try again later.", "Error");
        }
      })
    }
  }

  private loadPage(page = null) {
    this.loading = true;
    this.advertisers = [];
    let params = this.formParam(page);

    // get page of items from api
    this.advertiserSvc.getAll(params).pipe(first()).subscribe(data => {
      if (data !== null) {
        this.loading = false;
        this.emptyResult = false;
        this.totalItems = data.data.total;
        this.advertisers = data.data.list;
        this.currentPage = data.data.page + 1;
        this.maxPageSize = Math.ceil(data.data.total / data.data.pageSize) < 1 ? 1 : Math.ceil(data.data.total / data.data.pageSize);
      } else {
        this.loading = false;
        this.emptyResult = true;
        this.maxPageSize = 0;
        this.notification.showWarning("There is no record for this admin.", "Empty Result");
      }
    });
  }

  private formParam(page = null) {
    let params = {
      pageSize: this.itemsPerPage || 20,
      page: page == null ? this.currentPage - 1 : page - 1,
      advertiser: this.filterable.advertiser,
      offerId: this.filterable.offerId,
    }
    return params;
  }

}
